import window from "../WindowExtended";
import {PaymentController} from "./PaymentController";
import {Checkout, CustomerFactory, IPaymentTransaction} from "../../../typescript-library";
import {getShopId} from "../getShopId";
import {FUNDING_SOURCE} from "@paypal/paypal-js";

export type OnApproveInfoType = {
  lastPaymentTransaction: IPaymentTransaction | null;
  lastWorkingCall: string | null;
};

type InternalPurchaseParamsType = {
  checkout: Checkout;
  nonce?: string;
  paymentSource?: FUNDING_SOURCE;
};

export const purchase: (params: InternalPurchaseParamsType) => Promise<void> = async ({
  checkout,
  nonce,
  paymentSource,
}) => {
  const info: OnApproveInfoType = {
    lastPaymentTransaction: null,
    lastWorkingCall: null,
  };
  try {
    // check if there is a customer remark that has not yet been sent
    if (window.annotationTextArea !== (checkout.customerRemark ?? undefined)) {
      await checkout.put({customerRemark: window.annotationTextArea});
      info.lastPaymentTransaction = checkout.paymentTransaction;
      info.lastWorkingCall = "CustomerRemarkPut";
    }
    info.lastPaymentTransaction = await PaymentController.initPayment();
    info.lastWorkingCall = "InitPayment";
    // Use the following line to test gateway rejections
    // (https://developer.paypal.com/braintree/docs/guides/premium-fraud-management-tools/testing-go-live/php)
    // `info.lastPaymentTransaction = await PaymentController.authorizePayment("fake-gateway-rejected-risk-thresholds-nonce");`
    info.lastPaymentTransaction = await PaymentController.authorizePayment(nonce);
    info.lastWorkingCall = "AuttPayment";
    // check if we have to make a separate newsletter registration (necessary for guest purchases)
    if (checkout.hasNewsletter && checkout.isGuest && checkout.invoiceAddress) {
      await CustomerFactory.createOrUpdateCustomer(getShopId(), {
        email: checkout.invoiceAddress.email,
        newsletterFlag: true,
      });
    }
    await checkout.purchase();
  } catch (err) {
    (err as Error).name = "Purchase" + (err as Error).name;
    (err as Error & {info: OnApproveInfoType}).info = info;
    (err as Error & {paymentSource: FUNDING_SOURCE | undefined}).paymentSource = paymentSource;
    throw err;
  }
};
